import App from './App.svelte';
import './styles/tokens.css';
import './app.css';

const target = document.getElementById('app');
if (!target) throw new Error('#app missing');

const app = new App({ target });
export default app;
